module.exports = __webpack_public_path__ + "static/media/Rachel K.6a23d07e.jpg";